import cx from "classnames"
import Link from "next/link"
import { getPlayerPageUrl } from "../../../../utils/urls"
import style from "./style.module.scss"
import { Row, Col } from "react-bootstrap"
import { Tabs } from "@components/UI/Tabs"
import { PlayerCompetitionSeasonsStats } from "@components/CompetitionSeasonStats/PlayerCompetitionSeasonsStats"
import { CompetitionSeasonPlayerCompetitionSeasonParameterFlat } from "types/competitionSeasonPlayerStats"
import { useRouter } from "next/router"
import { Select } from "antd"
import { useState } from "react"

const buttons = [
  {
    key: "statistiche",
    label: "Statistiche",
  },
  {
    key: "bilancio",
    label: "Bilancio/avversario",
  },
  {
    key: "bilancio-arbitro",
    label: "Bilancio/arbitro",
  },
]

export function PlayerMenu({
  selected,
  playerCalciocomSlug,
  playerCompetitionSeasonStats,
  player,
}: {
  selected: string
  playerCalciocomSlug: string
  playerCompetitionSeasonStats: CompetitionSeasonPlayerCompetitionSeasonParameterFlat[]
  player: any
}) {
  const router = useRouter()

  const [selectedStats, setSelectedStats] = useState<CompetitionSeasonPlayerCompetitionSeasonParameterFlat>()

  const selectedFromUrl = router.query.selected as string | undefined
  const initialSelectedKey = selectedFromUrl || selected || buttons[0].key

  const handleButtonClick = (key: string) => {
    const url = getPlayerPageUrl(playerCalciocomSlug, key)
    router.push(url)
  }

  const handleTabChange = (selectedId: string | number) => {
    handleButtonClick(selectedId as string)
  }

  return (
    <div className={style.playerMenuMainContainer}>
      <Row className={style.container}>
        <Col xs={8} sm={8} md={8} lg={8} xl={8} className={style.linksContainer}>
          {buttons.map(({ key, label }) => {
            const url = getPlayerPageUrl(playerCalciocomSlug, key)
            return (
              <div key={key} className={cx(style.link, selected === key && style.active)}>
                <Link href={url}>
                  <a title={label}>{label}</a>
                </Link>
              </div>
            )
          })}
        </Col>
        <Col xs={12} sm={12} md={12} className={style.mobileSelector}>
          <Tabs
            className={`competition-tabs-cc dark`}
            selectedId={initialSelectedKey}
            options={buttons.map((b) => {
              return {
                value: b.key,
                label: b.label,
              }
            })}
            onChange={handleTabChange}
          />
        </Col>
        <Col xs={12} sm={12} md={12} lg={4} xl={4} className={style.seasonSelector}>
          <div className={style.selector}>
            {playerCompetitionSeasonStats && playerCompetitionSeasonStats.length > 0 && (
              <Select
                className={style.select + " selectantd"}
                value={selectedStats?.competitionSeason.id}
                defaultValue={playerCompetitionSeasonStats[0].competitionSeason.id}
                options={playerCompetitionSeasonStats.map((cs) => {
                  return {
                    value: cs.competitionSeason.id,
                    label: cs.competitionSeason.name,
                  }
                })}
                onChange={(value) =>
                  setSelectedStats(playerCompetitionSeasonStats.find((cs) => cs.competitionSeason.id === value)!)
                }
              />
            )}
          </div>
        </Col>
      </Row>
      <Row>
        {playerCompetitionSeasonStats?.length > 0 && (
          <PlayerCompetitionSeasonsStats role={player.role} stats={selectedStats || playerCompetitionSeasonStats[0]} />
        )}
      </Row>
    </div>
  )
}
